<template>
  <form @submit.prevent="submit">
    <div class="field">
      <label>Proveedor de IA</label>
      <Dropdown v-model="form.ai_provider_id" :options="providers" optionLabel="name" optionValue="id"
        placeholder="Selecciona un proveedor" class="w-full" />
    </div>
    <div class="field">
      <label>API Key propia</label>
      <Password v-model="form.api_key" class="w-full" :feedback="false" toggleMask />
    </div>
    <div class="field-check">
      <Checkbox v-model="form.is_default" :binary="true" inputId="isDefault" />
      <label for="isDefault">Usar como proveedor por defecto</label>
    </div>
    <Button label="Guardar credencial" type="submit" :loading="loading" class="w-full" />
  </form>
</template>

<script setup>
import { ref } from 'vue';
import Dropdown from 'primevue/dropdown';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import { useAuthStore } from '../../stores/auth';
import api from '../../services/api';

const emit = defineEmits(['saved']);
const authStore = useAuthStore();
const form = ref({ ai_provider_id: null, api_key: '', is_default: false });
const providers = ref([{ id: 1, name: 'Mistral AI' }, { id: 2, name: 'OpenAI' }]);
const loading = ref(false);

const submit = async () => {
  loading.value = true;
  try {
    await api.post('/credentials/tenant', {
      ...form.value,
      tenant_id: authStore.user?.tenant_id,
    });
    emit('saved');
    form.value = { ai_provider_id: null, api_key: '', is_default: false };
  } catch (e) { console.error(e); }
  finally { loading.value = false; }
};
</script>

<style scoped>
.field { margin-bottom: 1rem; }
.field label { display: block; margin-bottom: 0.4rem; font-weight: 500; }
.field-check { display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1rem; }
.w-full { width: 100%; }
</style>
